import { DataBaseNodes } from '@lib';
import { SERVER_VERSION } from '@configs';
import { SourceUnsubscribe } from '@type';
import { isInferiorVersion } from '@utils';

import { BaseGateway } from './base.gateway';

export class SourceGateway extends BaseGateway {
  authenticate = async () =>
    await this.sourceService.authenticate().catch(() => false);

  getMaintenanceMode = async () => {
    return await this.sourceService.getMaintenanceMode();
  };

  getServerVersion = async () => {
    return await this.sourceService.getServerVersion();
  };

  readonly subscribeToMaintenanceMode = (
    callback: () => unknown
  ): SourceUnsubscribe => {
    return this.sourceService.subscribeToChild(
      `${DataBaseNodes.MaintenanceMode}`,
      snapshot => {
        if (!snapshot.exists()) return;

        const data = snapshot.val() as boolean;
        if (data) callback();
      }
    );
  };

  readonly subscribeToShouldUpdateApp = (
    callback: () => unknown
  ): SourceUnsubscribe => {
    return this.sourceService.subscribeToChild(
      `${DataBaseNodes.ServerVersion}`,
      snapshot => {
        if (!snapshot.exists()) return;

        const data = snapshot.val() as string;
        if (isInferiorVersion(SERVER_VERSION, data)) callback();
      }
    );
  };
}
